import React, { useState, useCallback, useEffect } from 'react';
import RoundCheckbox from '../../common/RoundCheckbox';
import { s3Link } from '../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactSortable } from 'react-sortablejs';

const StashSelected = ({
    medias,
    addSelectStash,
    handleSelectFreePreview,
    freePreview,
    ppvPrice = 0,
    setStashSelected,
    setReshuffled,
    reshuffled
}) => {
    const [hasFreePreview, setHasFreePreview] = useState(false);

    const handleFreePreview = useCallback(() => {
        setHasFreePreview(hasFreePreview => !hasFreePreview);
        // setReshuffled(reshuffled => reshuffled + 1);
    }, [hasFreePreview]);

    const handleSelect = (file) => {
        if (hasFreePreview) {
            handleSelectFreePreview(file);
        }
    };

    const handleOnSort = () => {
        if (hasFreePreview && Boolean(ppvPrice)) {
            setReshuffled(reshuffled => reshuffled + 1);
        }
    };

    useEffect(() => {
        if (!hasFreePreview) {
            handleSelectFreePreview({});
        } else {
            setReshuffled(reshuffled => reshuffled + 1);
        }
    }, [hasFreePreview]);

    useEffect(() => {
        setHasFreePreview(freePreview && Object.keys(freePreview).length > 0);
    }, [freePreview]);

    const Extension = ({ file }) => {
        const extension = file.file_path.split('.');
        return extension[extension.length - 1].toUpperCase();
    };

    return <>
        {
            Boolean(ppvPrice) && medias.length > 1 && <div className="free-preview mb-0">
                <RoundCheckbox
                    label="Free Preview"
                    checked={hasFreePreview}
                    onChange={handleFreePreview}
                />
            </div>
        }
        <div className="images ppv-images-cont">
            <ReactSortable
                className="files__container"
                draggable=".images__wrapper"
                handle=".free-preview__movable"
                list={medias}
                setList={setStashSelected}
                animation={200}
                ghostClass="sortable-ghost"
                chosenClass="sortable-chosen"
                dragClass="sortable-drag"
                scroll={false}
                forceFallback={true}
                onSort={handleOnSort}
            >
                {
                    medias.map((file, index) => (
                        <div
                            className={`images__wrapper
                                ${file?.media_id == freePreview.media_id
                                    ? ' free-preview__active'
                                    : ''
                                } ${file?.media_id ? file.media_id : ''}`
                            }
                            key={index}
                        >
                            <div
                                className={`image
                                ${hasFreePreview
                                        ? ' free-preview__clickable'
                                        : ''
                                    }`
                                }
                            >
                                <span
                                    className="close remove-stash"
                                    onClick={() => addSelectStash(file.media_id, file.thumb_path, file)}
                                >
                                    <FontAwesomeIcon icon={['fas', 'times']} />
                                </span>
                                <img src={`${s3Link}/${file.thumb_path}`} alt="" />

                                {file.media_id == freePreview.media_id && <span className="free-preview__label">
                                    Free Preview
                                </span>}

                                <span className="free-preview__type">
                                    <Extension file={file} />
                                </span>

                                {hasFreePreview && <span
                                    className='free-preview__select'
                                    onClick={() => handleSelect(file)}
                                ></span>}
                            </div>
                            <div className='free-preview__movable'>
                                <i className="fa-solid fa-grip-dots"></i>
                            </div>
                        </div>
                    ))
                }
            </ReactSortable>
        </div>
    </>;
};

export default React.memo(StashSelected);